// extracted by mini-css-extract-plugin
module.exports = {"Resolution":"Resolution--3_ML7","validated-yes":"validated-yes--3qEPf","validated-no":"validated-no--16NhO","validated-maybe":"validated-maybe--1hQRA"};